import {axiosApi} from "./api";
// 登录接口
export let loginInt = fromdata => {
    return axiosApi({
        url: "api/login",
        method: "POST",
        data:fromdata
    });
};
// 登出
export let logoutInt = fromdata => {
    return axiosApi({
        url: "api/logout",
        method: "POST",
        data:fromdata
    });
};

// 注册接口
export let registerInt = fromdata => {
    return axiosApi({
        url: "api/register",
        method: "POST",
        data:fromdata
    });
};


// s首页数据统计
export let statInterface = (fromdata) => {
	return axiosApi({
		url: "/api/stat",
		method: "get",
		params:fromdata
	});
};

// 修改密码  /api/password
export let ChangePassword = fromdata => {
    return axiosApi({
        url: "/api/password/change",
        method: "POST",
        data:fromdata
    });
};

//验证码
export let ImgsRandom = fromdata => {
    return axiosApi({
        url: "/api/captcha",
        method: "POST",
        responseType:'blob',
        data:fromdata
    });
};


//
//下拉框配置表
export let configInterface = (fromdata) => {
    return axiosApi({
        url: "/sysapi/config",
        method: "get",
        params:fromdata
    });
};

//获取忘记密码验证码
export let verifyInt = fromdata => {
    return axiosApi({
        url: "/api/sms/send",
        method: "POST",
        data:fromdata
    });
};
//
export let ForgetFormInt = fromdata => {
    return axiosApi({
        url: "/api/password/change",
        method: "POST",
        data:fromdata
    });
};
